import { Inventory } from '@cibo/core'
import * as d3 from 'd3'

const LATEST_OFFTAKE_YEAR = 2023

export class InventoryModel {
  inventory: Inventory

  constructor(params: Inventory) {
    this.inventory = params
  }

  get hasOfftakeData() {
    return this.inventory?.boundaries.some(({ data }) => !!data.cropOfftakes)
  }

  get offtakeYears() {
    if (!this.inventory?.years) return

    const firstBaselineYear = d3.min(this.inventory.years) as number
    if (firstBaselineYear >= LATEST_OFFTAKE_YEAR) {
      return [LATEST_OFFTAKE_YEAR]
    }
    return d3.range(firstBaselineYear, LATEST_OFFTAKE_YEAR + 1)
  }
}
